<template>
  <MRow :gutter="0">
    <MCol :lg="12" :sm="12" auto-size>
      <MRow :gutter="0">
        <MCol :size="6" class="pr-2">
          <FlotoFormItem
            id="quantity-input"
            rules="required|nonzero"
            :label="$t('quantity')"
          >
            <MInputNumber
              v-model="formData.quantity"
              :disabled="disabled"
              :placeholder="$t('quantity')"
              :precision="0"
            />
          </FlotoFormItem>
        </MCol>
        <MCol :size="6" class="pl-2">
          <FlotoFormItem
            id="purchase-cost-input"
            rules="min_value:1|max_value"
            :label="`${$tc('purchase')} ${$tc('cost')}`"
          >
            <MInputGroup compact class="input-group-container mb-2">
              <MInputNumber
                v-model="formData.purchaseCost"
                :precision="2"
                :placeholder="$t('price')"
              />
              <CurrencyPicker
                v-model="formData.currencyId"
                :allow-clear="false"
              />
            </MInputGroup>
          </FlotoFormItem>
        </MCol>
      </MRow>
      <MRow>
        <MCol :size="6" class="pr-2">
          <FlotoFormItem
            id="purchase-date-picker"
            :label="`${$tc('purchase')} ${$t('date')}`"
          >
            <FlotoDatePicker
              v-model="formData.purchaseDate"
              :show-time="false"
            />
          </FlotoFormItem>
        </MCol>
        <MCol :size="6" class="pl-2">
          <FlotoFormItem
            id="expiry-date-picker"
            :label="`${$t('expiry')} ${$t('date')}`"
          >
            <FlotoDatePicker v-model="formData.expiryDate" :show-time="false" />
          </FlotoFormItem>
        </MCol>
      </MRow>
      <MRow>
        <MCol :size="6" class="pr-2">
          <FlotoFormItem id="vendor-id-picker" :label="$tc('vendor')">
            <VendorPicker
              v-model="formData.vendorId"
              :placeholder="$t('select')"
            />
          </FlotoFormItem>
        </MCol>
        <MCol :size="6" class="pl-2">
          <FlotoFormItem
            id="expiry-date-picker"
            v-model="formData.barCode"
            :label="`${$t('barcode')}`"
            :placeholder="`${$t('barcode')}`"
          />
        </MCol>
      </MRow>
      <FlotoFormItem
        id="description-input"
        v-model="formData.description"
        :placeholder="$t('description_instruction')"
        :label="$t('description')"
        :rows="2"
        type="textarea"
      />
      <FlotoFormItem :label="$tc('attachment', 2)">
        <FlotoAttachment v-model="formData.fileAttachments" />
      </FlotoFormItem>
    </MCol>
  </MRow>
</template>

<script>
import CurrencyPicker from '@components/data-picker/currency-picker'
import VendorPicker from '@components/data-picker/vendor-picker'
export default {
  name: 'QuantityForm',
  components: { CurrencyPicker, VendorPicker },
  props: {
    formData: { type: Object, required: true },
  },
  computed: {
    disabled() {
      if (this.formData.id && !this.formData.canEdit) {
        return true
      }
      return false
    },
  },
}
</script>
